
import { PatientInvitationDashboard } from "@/components/patient-invitations/PatientInvitationDashboard";

const PatientInvitations = () => {
  return <PatientInvitationDashboard />;
};

export default PatientInvitations;
